<template>
  <div>
    <vx-card>
      <ListPerfis :subjectPermission="subjectPermission"></ListPerfis>
    </vx-card>
  </div>
</template>

<script>
import ListPerfis from "./../../lists/ListPerfis";

export default {
  data() {
    return {
      subjectPermission: "Perfil de Usuário",
    };
  },
  methods: {},
  components: {
    ListPerfis,
  },
};
</script>
